// extracted by mini-css-extract-plugin
export var cls1 = "index-module--cls1--ugd9G";
export var cls2 = "index-module--cls2--M8tnA";
export var cls3 = "index-module--cls3--jUOru";
export var cls4 = "index-module--cls4--jIe8M";
export var logo = "index-module--logo--Ab6EH";
export var logoFill = "index-module--logoFill--oTntG";